import {CommonModule} from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  signal,
  ViewChild
} from '@angular/core';
import {MatDialogModule} from '@angular/material/dialog';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatTableModule} from '@angular/material/table';
import {ContentLoaderComponent, SecondaryButtonComponent} from '@q9elements/ui-kit/components';
import {TranslateModule} from '@ngx-translate/core';
import {ConfigService, Q9HtmlDecoderPipe, Q9HtmlEncoderPipe} from '@q9elements/ui-kit/common';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatIconModule} from '@angular/material/icon';
import {IDiagramVersionChildren} from '../../../models/diagram-version.model';
import {GetAuthorisableIconPipe} from '../../../pipes/get-authorisable-icon.pipe';
import {GetDiagramStateLabelPipe} from '../../../pipes/get-diagram-state-label.pipe';
import {GetScreenshotConfigPipe} from '../../../pipes/get-screenshot-config.pipe';
import {ScreenshotPopoverDirective} from '../../../directives/screenshot-popover.directive';
import {TooltipOnOverflowDirective} from '../../../directives/tooltip-on-overflow.directive';
import {RequestsService} from 'src/app/core/requests/requests.service';
import {RequestTask} from 'src/app/shared/models/request-task.interface';
import {DiagramJsonHandlerService} from 'src/app/diagram-data/diagram-json-handler.service';

@Component({
  selector: 'app-lower-levels-content',
  templateUrl: './lower-levels-content.component.html',
  styleUrls: ['./lower-levels-content.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatDialogModule,
    SecondaryButtonComponent,
    TranslateModule,
    Q9HtmlEncoderPipe,
    Q9HtmlDecoderPipe,
    MatTooltipModule,
    GetScreenshotConfigPipe,
    GetDiagramStateLabelPipe,
    GetAuthorisableIconPipe,
    ScreenshotPopoverDirective,
    TooltipOnOverflowDirective,
    MatIconModule,
    ContentLoaderComponent
  ]
})
export class LowerLevelsContentComponent implements OnInit {
  @Input() public override: boolean;

  @Output() public backToSubmission = new EventEmitter<void>();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  public dataSource: IDiagramVersionChildren[];
  public diagramList: IDiagramVersionChildren[];
  public displayedColumns: string[] = ['checkboxes', 'level', 'diagram', 'state'];
  public pageSize = 10;
  public noItemsImage = `${ConfigService.environment.STATIC_FILES_URL}/icons/placeholders/empty.svg`;
  public isLoading = signal(false);

  constructor(
    private requestsSvc: RequestsService,
    private diagramJsonSvc: DiagramJsonHandlerService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.fetchChildren();
  }

  get getDiagramChildren(): RequestTask {
    return {
      isApi: true,
      method: 'GET',
      url: `/authorisation/${this.diagramJsonSvc.get().diagramId}/availableChildren`
    };
  }

  public updateDataSource(): void {
    const end = (this.paginator.pageIndex + 1) * this.paginator.pageSize;
    const start = this.paginator.pageIndex * this.paginator.pageSize;

    this.dataSource = [...this.diagramList].slice(start, end);
    this.cdr.detectChanges();
  }

  private async fetchChildren() {
    try {
      this.isLoading.set(true);
      this.diagramList = await this.requestsSvc.addToQueue(this.getDiagramChildren, true);
      this.updateDataSource();
    } catch (error) {
      this.backToSubmission.emit();
    } finally {
      this.isLoading.set(false);
    }
  }
}
